// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"a0f65a64","462":"b35c642f"}[chunkId] + ".chunk.js";
};